import { EdytujSrodekModel } from '../projekty/spis/edytujSrodekModel';

export class EdytujSrodekOswiadczeniaModel extends EdytujSrodekModel {
  idUzytkownika: string;
}
